import React from 'react';
import PropTypes from 'prop-types';

import { SeatElements as ThroneSeatElements } from '@weezevent/throne';
import { useTranslation } from 'react-i18next';

function LegendItem({ name, Image, count = null, isSocialDistancing = true }) {
    const { t } = useTranslation();

    if ((name === 'Social Distancing' && !isSocialDistancing) || !count) {
        return null;
    }

    const getKeyTranslate = name => {
        let _name = name.split(' ').join('');
        return `ticket.common.seating.${_name.charAt(0).toLowerCase() + _name.slice(1)}`;
    };

    return (
        <div className="availability-legend-item">
            <span>
                <Image />
                <span>{t(getKeyTranslate(name))}</span>
            </span>
            <span className="availability-legend-item__container-count">
                <span>{`x`}</span>
                <span className="availability-legend-item__count">{count || 0}</span>
            </span>
        </div>
    );
}

LegendItem.propTypes = {
    name: PropTypes.string.isRequired,
    Image: PropTypes.node.isRequired,
    count: PropTypes.number
};

export function SeatMapLegend({ seats = [], isSocialDistancing = true }) {
    const { t } = useTranslation();

    const seatsCount = React.useMemo(() => {
        let count = {};
        if (!seats?.length) {
            return count;
        }
        Object.keys(ThroneSeatElements).forEach(state => {
            count[state] = seats.filter(seat => seat.booking_state.toUpperCase() === state.toUpperCase()).length;
        });
        return count;
    }, [seats]);

    return (
        <div className="willy-availability-legend">
            <div className="willy-availability-legend-title">{t('ticket.swapSeat.legendZone')}</div>
            <div className="willy-availability-legend-list">
                <LegendItem name="Available" Image={ThroneSeatElements.available} count={seatsCount['available']} />
                <LegendItem name="Partially Available" Image={ThroneSeatElements.partially_available} count={seatsCount['partially_available']} />
                <LegendItem name="Booked" Image={ThroneSeatElements.booked} count={seatsCount['booked']} />
                <LegendItem name="Partially Booked" Image={ThroneSeatElements.partially_booked} count={seatsCount['partially_booked']} />
                <LegendItem name="Booking In Progress" Image={ThroneSeatElements.booking_in_progress} count={seatsCount['booking_in_progress']} />
                <LegendItem name="Partially Booking In Progress" Image={ThroneSeatElements.partially_booking_in_progress} count={seatsCount['partially_booking_in_progress']} />
                <LegendItem name="Reserved" Image={ThroneSeatElements.booked_by_reservation} count={seatsCount['booked_by_reservation']} />
                <LegendItem name="Unavailable" Image={ThroneSeatElements.unavailable} count={seatsCount['unavailable']} />
                <LegendItem
                    name="Social Distancing"
                    Image={ThroneSeatElements.locked_for_social_distancing}
                    count={seatsCount['locked_for_social_distancing']}
                    isSocialDistancing={isSocialDistancing}
                />
            </div>
        </div>
    );
}

SeatMapLegend.propTypes = {
    seats: PropTypes.array
};

export default ThroneSeatElements;
